import { render } from "./SpaceSwitcher.vue?vue&type=template&id=106dccb4&scoped=true"
import script from "./SpaceSwitcher.vue?vue&type=script&lang=js"
export * from "./SpaceSwitcher.vue?vue&type=script&lang=js"

import "./SpaceSwitcher.vue?vue&type=style&index=0&id=106dccb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106dccb4"]])

export default __exports__